import authorizedAxios from "../utils/authorizedAxios";

const logIn = async (email, password) => {
  const res = await authorizedAxios.post("/auth/login", {
    email: email,
    password: password,
  });

  return res.data;
};

const logOut = async () => {
  const res = await authorizedAxios.delete("/auth/logout");
  return res.data;
};

const refreshToken = async () => {
  return await authorizedAxios.put("/auth/refresh_token");
};

const getUserInfo = async () => {
  return await authorizedAxios.get("/auth/test");
};

const register = async (email, password, passwordConfirm) => {
  try {
    const res = await authorizedAxios.post("/auth/register", {
      email: email,
      password: password,
      passwordConfirm: passwordConfirm,
    });
    return res.data;
  } catch (err) {
    if (err.response) {
      return err.response.data;
    }
    return err;
  }
};

const googleLogin = () => {
  window.location.href = `${process.env.REACT_APP_SERVER_URL}/auth/google`;
};

const googleLoginCallback = async () => {
  try {
    const res = await authorizedAxios.get("/auth/google/redirect", {
      withCredentials: true,
    });
    if (res.data.success === true) {
      localStorage.setItem("accessToken", res.data.data.accessToken);
      localStorage.setItem("refreshToken", res.data.data.refreshToken);
      localStorage.setItem("userInfo", JSON.stringify(res.data.data.user));
      return res.data;
    }
  } catch (err) {
    if (err.response) {
      return err.response.data;
    }
    return err;
  }
};

const UserService = {
  logIn,
  logOut,
  refreshToken,
  getUserInfo,
  register,
  googleLogin,
  googleLoginCallback,
};

export default UserService;
